import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { GlobalSearch } from '@/features/search';
import NotificationBell from '@/features/notifications/NotificationBell';
import UserProfileMenu from '@/app/layouts/UserProfileMenu';
import { MenuIcon } from '@/shared/icons';
import { iconTouchTargetSquareClassName } from '@/shared/config/theme';

interface TopBarProps {
  className?: string;
  searchPlaceholder?: string;
  onMenuClick?: () => void;
}

export default function TopBar({ className, searchPlaceholder, onMenuClick }: TopBarProps) {
  const { t } = useTranslation(['common', 'nav']);
  const placeholder = searchPlaceholder ?? t('search', { ns: 'common' });

  return (
    <header
      className={clsx(
        'flex h-16 shrink-0 items-center gap-3 border-b border-gray-300 bg-white px-4 lg:px-6',
        className,
      )}
    >
      <button
        type="button"
        onClick={onMenuClick}
        className={clsx(iconTouchTargetSquareClassName, 'lg:hidden')}
        aria-label={t('openMenu', { ns: 'nav' })}
      >
        <MenuIcon className="h-6 w-6 text-gray-700" />
      </button>

      <div className="hidden min-w-0 flex-1 sm:block lg:mx-auto lg:max-w-2xl">
        <GlobalSearch placeholder={placeholder} />
      </div>

      <div className="ml-auto flex shrink-0 items-center gap-1 sm:gap-2 lg:ml-6">
        <NotificationBell />
        <UserProfileMenu />
      </div>
    </header>
  );
}
